export default "__VITE_ASSET__DBGrh2Ls__"